var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 14.7307C3.94999 14.7307 0.666656 11.4474 0.666656 7.39736C0.666656 3.34736 3.94999 0.0640259 7.99999 0.0640259C12.05 0.0640259 15.3333 3.34736 15.3333 7.39736C15.3333 11.4474 12.05 14.7307 7.99999 14.7307ZM7.99999 13.3974C11.314 13.3974 14 10.7114 14 7.39736C14 4.08336 11.314 1.39736 7.99999 1.39736C4.68599 1.39736 1.99999 4.08336 1.99999 7.39736C1.99999 10.7114 4.68599 13.3974 7.99999 13.3974ZM7.33332 4.73069C7.33332 4.36269 7.63199 4.06403 7.99999 4.06403C8.36799 4.06403 8.66666 4.36269 8.66666 4.73069V7.39736C8.66666 7.76536 8.36799 8.06403 7.99999 8.06403C7.63199 8.06403 7.33332 7.76536 7.33332 7.39736V4.73069ZM7.52866 9.86869C7.26799 9.60803 7.26799 9.18603 7.52866 8.92603C7.78932 8.66603 8.21132 8.66536 8.47132 8.92603C8.73199 9.18669 8.73199 9.60869 8.47132 9.86869C8.21066 10.1287 7.78866 10.1294 7.52866 9.86869Z",
    fill: "#D62E4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.6ffff0d3f29f39678251e06c38888bda.svg";
export { ForwardRef as ReactComponent };